export const normalizeUrl = (value)=>{
    if (!value) {
        return '';
    }
    const stripped = value.replace(/^(https?:)?\/\//, '').trim();
    return stripped ? `https://${stripped}` : '';
};

//# sourceMappingURL=normalizeUrl.js.map